export const FChangeDate = (date, fmt = 'yyyy/MM/dd') => { //formate the time
  let o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

export const FSetCookie = (key, value) => { // Save the value into the cookie
  let date = new Date();
  let expiresDays = 30;
  date.setTime(date.getTime() + expiresDays * 24 * 3600 * 1000);
  document.cookie = key + "=" + value + ";expires=" + date.toGMTString() + ';path=/';
}

export const FGetCookie = (key) => { // Get the value from cookie
  let strCookie = document.cookie
  strCookie = strCookie.replace(/\s/g, '')
  let arrCookie = strCookie.split(';')
  for (let i = 0; i < arrCookie.length; i++) {
    let arr = arrCookie[i].split('=')
    if (key === arr[0] && arr[1] !== '') {
      return arr[1]
    }
  }
  return ''
}

/**
 * 数据脱敏
 */
export const dataDst = (data) => {
  if (!data) return;
  //转成string,判断长度
  data = String(data);
  if (data.length == 0) return;
  let mark = '****';
  let phoneReg = /^(13|14|15|16|17|18|19)\d{9}$/;
  //是手机号码
  if (phoneReg.test(data)) {
    return `${data.slice(0,3)}${mark}${data.slice(-4)}`;
  }
  if (data.length >= 3) {
    let customMark = '******'

    return `${data[0]}${customMark}${data[data.length - 1]}`;
  } else if (data.length <= 3) {
    return `${data[0]}*`;
  }
  return data;
}

/**
 * 获取url 参数
 * @param {*} data
 */
export const getUrlParam = (data) => {
  let qs = location.search.substr(1), // 获取url中"?"符后的字串
    args = {}, // 保存参数数据的对象
    items = qs.length ? qs.split("&") : [], // 取得每一个参数项,
    item = null,
    len = items.length;

  for (let i = 0; i < len; i++) {
    item = items[i].split("=");
    let name = decodeURIComponent(item[0]),
      value = decodeURIComponent(item[1]);
    if (name) {
      args[name] = value;
    }
  }
  return args;
}

//判断数组是否为空
export const isArrayNull = data => {
  return data && data.length
}



// WEBPACK FOOTER //
// ./src/common/util.js